export const NO_CONTENT = 204;
export const CODE_UNAUTHORIZED = 401;
export const BAD_REQUEST = 400;
export const NOT_ALLOWED = 403;
export const NOT_FOUND = 404;
export const INTERNAL_ERROR = 500;

export const REQUEST_NOT_STARTED = 'idle';
export const REQUEST_PENDING = 'pending';
export const REQUEST_RESOLVED = 'resolved';
export const REQUEST_REJECTED = 'rejected';
